var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !!_vm.params.data.fileId && _vm.params.data.type === 6,
            expression: "!!params.data.fileId && params.data.type === 6"
          }
        ]
      },
      [
        _c(
          "el-button",
          {
            attrs: { type: "text", plain: "" },
            on: { click: _vm.downloadSopEmail }
          },
          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InvoiceHistoryEmail")))]
        )
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              !!_vm.params.data.fileId &&
              _vm.params.data.type !== 5 &&
              _vm.params.data.type !== 6,
            expression:
              "!!params.data.fileId && params.data.type !== 5 && params.data.type !== 6"
          }
        ]
      },
      [
        _c(
          "el-button",
          {
            attrs: { type: "text", plain: "" },
            on: { click: _vm.downloadSopEmail }
          },
          [_vm._v("Sop" + _vm._s(_vm.$t("Viewer.email")))]
        )
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !!_vm.params.data.fileId && _vm.params.data.type === 5,
            expression: "!!params.data.fileId && params.data.type === 5"
          }
        ]
      },
      [
        _c(
          "el-button",
          {
            attrs: { type: "text", plain: "" },
            on: { click: _vm.downloadSopEmail }
          },
          [
            _vm._v(
              _vm._s(_vm.$t("CargoMsg.Cargo_FileHistory")) +
                _vm._s(_vm.$t("Viewer.email"))
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }